import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}))

function CC_FAQ_page() {
  return (
    <div>
      <div className="mt-5">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <CC_FAQ />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-sm-block d-md-none mb-5">
              <CC_FAQ />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function CC_FAQ() {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }
  return (
    <>
      <div className={classes.root}>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What certifications are most valuable for cloud computing jobs?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Some of the most sought-after certifications are:
              <ul>
                <li>AWS Certified Solutions Architect</li>
                <li>Microsoft Certified: Azure Solutions Architect Expert</li>
                <li>Google Professional Cloud Architect, CompTIA Cloud+</li>
                <li>Certified Cloud Security Professional (CCSP)</li>
              </ul>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What are the main job roles in cloud computing?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Common roles include:
              <ul>
                <li>Cloud Solutions Architect, Cloud Engineer</li>
                <li>Cloud Developer, Cloud Security Specialist</li>
                <li>DevOps Engineer, Cloud Data Engineer</li>
              </ul>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What are the key skills required for a career in cloud computing?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Essential skills include proficiency in cloud platforms (AWS,
              Azure, Google Cloud), knowledge of networking, understanding of
              virtualization, database management, programming skills (e.g.,
              Python, Java), and familiarity with DevOps practices, security
              protocols, and compliance.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel4'}
          onChange={handleChange('panel4')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4bh-content"
            id="panel3bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              How can I transition from traditional IT roles to cloud computing?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Transitioning involves upskilling with cloud certifications,
              gaining experience through cloud-based projects, and learning
              relevant tools and technologies (e.g., Docker, Kubernetes).
              Understanding cloud services and hands-on experience with
              platforms like AWS, Azure, or Google Cloud are essential.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel5'}
          onChange={handleChange('panel5')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel5bh-content"
            id="panel5bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What industries are adopting cloud computing, and where are the
              job opportunities?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Almost every industry is adopting cloud computing, including
              finance, healthcare, retail, government, and IT. The most
              opportunities are in sectors focusing on digital transformation,
              big data, artificial intelligence (AI), and remote work solutions.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  )
}
export default CC_FAQ_page
